import moment from 'moment';
import { React, useEffect, useMemo, useState } from 'react';
import {
    getTotalSalesAndAverageDailySales,
    getDailyResumeRegistrationStatus,
    getMonthlyResumeRegistrationStatus,
    getMemberStatistics,
    getDentalJobPaymentHistory,
    getDentalJobTicketPurchaseAndUsageStatus,
    getDentalJobTicketUseStatusByMonth,
    getDentalJobTicketUsageStatusByDay,
    dailyReport,
} from '../../../services/Api';

import DatePicker from 'react-datepicker';

import Loader from '../../../shared/components/Loader';
import SideMenu from '../../../shared/components/SideMenu';

import { MENU_STATISTICAL } from '../../../shared/constants/app';

const MAJAA000 = () => {
    const today = moment().toDate();

    const [selectedDate, setSelectedDate] = useState(
        moment().subtract(1, 'day').toDate(),
    );

    const [currentRevenueData, setCurrentRevenueData] = useState(null);
    const [prevRevenueData, setPrevRevenueData] = useState(null);
    const [dailySummary, setDailySummary] = useState([]);
    const [yearlySummary, setYearlySummary] = useState([]);
    const [recruitSummaryStats, setRecruitSummaryStats] = useState(null);
    const [memberStatsList, setMemberStatsList] = useState(null);

    const [analyticsTime, setanalyticsTime] = useState({
        year: moment(today).format('YYYY'),
        month: moment(today).format('MM'),
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchDailyReport = async () => {
            try {
                const sDate = moment(selectedDate).format('YYYYMMDD');

                const res = await dailyReport({ sDate });

                setCurrentRevenueData(res?.data?.currentYearRevenue || null);
                setPrevRevenueData(res?.data?.prevYearRevenue || null);
                setDailySummary(res?.data?.dailySummary || []);
                setYearlySummary(res?.data?.yearlySummary || []);
                setRecruitSummaryStats(res?.data?.recruitSummaryStats || null);
                setMemberStatsList(res?.data?.memberStatsList?.[0] || null,);
            } catch (error) {
                console.error('dailyReport error:', error);
            }
        };

        if (selectedDate) {
            fetchDailyReport();
        }
    }, [selectedDate]);

    const yearOptions = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const minYear = 2015;

        const years = [];

        for (let year = currentYear; year >= minYear; year--) {
            years.push(year);
        }

        return years;
    }, []);

    const getDropdownValues = (e) => {
        const { name, value } = e.target;

        setanalyticsTime((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const downloadFunctions = {
        sheet01: getTotalSalesAndAverageDailySales,
        sheet02: getDailyResumeRegistrationStatus,
        sheet03: getMonthlyResumeRegistrationStatus,
        sheet04: getMemberStatistics,
        sheet05: getDentalJobPaymentHistory,
        sheet06: getDentalJobTicketPurchaseAndUsageStatus,
        sheet07: getDentalJobTicketUseStatusByMonth,
        sheet08: getDentalJobTicketUsageStatusByDay,
    };

    const handleDownLoad = (pathKey, namefile) => {
        if (!selectedDate) {
            alert('날짜를 선택해 주세요');
            return;
        }

        setLoading(true);

        // const sDate =
        //     pathKey === 'sheet08'
        //         ? moment(selectedDate).format('YYYY')
        //         : moment(selectedDate).format('YYYYMMDD');

        const sDate = moment(selectedDate).format('YYYYMMDD');

        const downloadFunction = downloadFunctions[pathKey];

        downloadFunction({ sDate })
            .then((res) => {
                const fileName = `${namefile}.xls`;

                const url = window.URL.createObjectURL(
                    new Blob([res.data]),
                );

                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', fileName);

                document.body.appendChild(link);

                link.click();

                window.URL.revokeObjectURL(url);

                document.body.removeChild(link);

                setLoading(false);
            })
            .catch((error) => {
                console.error('Download error:', error);
                setLoading(false);
            });
    };

    const handleDateChange = (value) => {
        setSelectedDate(
            value ? value : moment().subtract(1, 'day').toDate(),
        );
    };

    return (
        <div className="container-fluid container statis-page majaa000">
            <div className="statistics-sale-history wrap">
                <SideMenu menu={MENU_STATISTICAL} />

                <div className="sale-history-management content-right">
                    <div className="title">일보고</div>

                    <div>
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th style={{ width: 150 }}>
                                        기준일자 선택
                                    </th>

                                    <td
                                        colSpan={3}
                                        style={{ textAlign: 'left' }}
                                    >
                                        <DatePicker
                                            style={{ width: 200 }}
                                            onChange={handleDateChange}
                                            locale="ko"
                                            placeholderText="YYYY/MM/DD"
                                            dateFormat="yyyy/MM/dd"
                                            selected={selectedDate}
                                            maxDate={today}
                                            showYearDropdown
                                            showMonthDropdown
                                            scrollableYearDropdown
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="group-content">
                        <div className="wrap-button">
                            <div
                                className="wrap-tiem"
                                data-title="덴탈잡 결제내역"
                            >
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'sheet05',
                                            `덴탈잡결제내역_${moment(
                                                selectedDate,
                                            ).format('YYYYMMDD')}`,
                                        );
                                    }}
                                >
                                    엑셀 다운로드
                                </button>
                            </div>

                            <div
                                className="wrap-tiem"
                                data-title="이용권 사용현황"
                            >
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'sheet06',
                                            `덴탈잡이용권구매및사용현황_${moment(
                                                selectedDate,
                                            ).format('YYYYMMDD')}`,
                                        );
                                    }}
                                >
                                    엑셀 다운로드
                                </button>
                            </div>

                            <div
                                className="wrap-tiem"
                                data-title="월별 광고상품 이용현황"
                            >
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'sheet07',
                                            `월별 광고상품 이용현황_${moment(
                                                selectedDate,
                                            ).format('YYYYMMDD')}`,
                                        );
                                    }}
                                >
                                    엑셀 다운로드
                                </button>
                            </div>

                            <div
                                className="wrap-tiem"
                                data-title="이용권 사용현황"
                            >
                                <button
                                    className="btn-item"
                                    disabled={loading}
                                    onClick={() => {
                                        handleDownLoad(
                                            'sheet08',
                                            `덴탈잡이용권사용현황_${moment(
                                                selectedDate,
                                            ).format('YYYY')}`,
                                        );
                                    }}
                                >
                                    엑셀 다운로드
                                </button>
                            </div>
                        </div>

                        {loading ? <Loader /> : ''}
                    </div>

                    <div className="table-padding-5">
                        <div
                            className="count-item red"
                        ><span style={{ fontWeight: 'bold', color: '#ff0000' }}>
                                {moment(selectedDate).format(
                                    'YYYY년 M월 D일',
                                )}{' '}기준 </span>
                            누적 매출 및 일평균 매출 (이용권 포함)
                        </div>
                    </div>

                    <div className="group-table">
                        <div className="group-child-table">
                            <table className="table table-gray w50">
                                <thead>
                                    <tr>
                                        <th>누적일자</th>
                                        <th>2026년도 누적 매출</th>
                                        <th>2026년 일평균 매출</th>
                                        <th>2025년 누적 매출</th>
                                        <th>2025년 일평균 매출</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {currentRevenueData && (
                                        <tr>
                                            <td>
                                                {currentRevenueData?.집계일수}일
                                            </td>

                                            <td>
                                                {Number(
                                                    currentRevenueData?.연간_결제합계금액 || 0,
                                                ).toLocaleString()}
                                            </td>

                                            <td>
                                                {Number(
                                                    currentRevenueData?.일평균_결제합계금액 || 0,
                                                ).toLocaleString()}
                                            </td>

                                            <td>
                                                {Number(
                                                    prevRevenueData?.연간_결제합계금액 || 0,
                                                ).toLocaleString()}
                                            </td>

                                            <td>
                                                {Number(
                                                    prevRevenueData?.일평균_결제합계금액 || 0,
                                                ).toLocaleString()}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </div>



                    <div className="table-padding-5">
                        <div
                            className="count-item red"
                        ><span style={{ fontWeight: 'bold', color: '#ff0000' }}>
                                {moment(selectedDate).format(
                                    'M월',
                                )}{' '}</span>
                            일별 이력서 등록 현황
                        </div>
                    </div>


                    <div className="group-table">
                        <div className="group-child-table">
                            <table className="calendar-table">
                                <thead>
                                    <tr>
                                        <th>월</th>
                                        <th>화</th>
                                        <th>수</th>
                                        <th>목</th>
                                        <th>금</th>
                                        <th>토</th>
                                        <th>일</th>
                                        <th>주계</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(() => {
                                        const currentMonth = moment(selectedDate);

                                        const startMonth = currentMonth
                                            .clone()
                                            .startOf('month');

                                        const startCalendar = startMonth
                                            .clone()
                                            .startOf('isoWeek');

                                        const endMonth = currentMonth
                                            .clone()
                                            .endOf('month');

                                        const endCalendar = endMonth
                                            .clone()
                                            .endOf('isoWeek');

                                        const totalDays =
                                            endCalendar.diff(startCalendar, 'days') + 1;

                                        const dataMap = new Map(
                                            dailySummary.map((d) => [
                                                moment(d.sdate).format('YYYY-MM-DD'),
                                                d,
                                            ]),
                                        );

                                        const days = [];

                                        for (let i = 0; i < totalDays; i++) {
                                            const day = startCalendar
                                                .clone()
                                                .add(i, 'days');

                                            const formattedDate =
                                                day.format('YYYY-MM-DD');

                                            days.push({
                                                date: day,
                                                data:
                                                    dataMap.get(formattedDate) ||
                                                    null,
                                            });
                                        }

                                        const totalWeeks = Math.ceil(days.length / 7);

                                        return Array.from({ length: totalWeeks }).map(
                                            (_, weekIdx) => {
                                                const weekDays = days.slice(
                                                    weekIdx * 7,
                                                    (weekIdx + 1) * 7,
                                                );

                                                const totalTodayCnt = weekDays.reduce(
                                                    (sum, day) =>
                                                        sum +
                                                        (day.data?.presumeYtoDayCnt || 0),
                                                    0,
                                                );

                                                const validDateCnt = weekDays.filter(
                                                    (day) =>
                                                        day.data?.presumeYDateCnt !==
                                                        undefined,
                                                );

                                                const avgDateCnt =
                                                    validDateCnt.length > 0
                                                        ? Math.round(
                                                            validDateCnt.reduce(
                                                                (sum, day) =>
                                                                    sum +
                                                                    (day.data
                                                                        ?.presumeYDateCnt ||
                                                                        0),
                                                                0,
                                                            ) / validDateCnt.length,
                                                        )
                                                        : 0;

                                                return (
                                                    <tr key={weekIdx}>
                                                        {weekDays.map((day, idx) => {
                                                            const isCurrentMonth =
                                                                day.date.month() ===
                                                                currentMonth.month();

                                                            return (
                                                                <td
                                                                    key={idx}
                                                                    className={
                                                                        !isCurrentMonth
                                                                            ? 'disabled-day'
                                                                            : ''
                                                                    }
                                                                >
                                                                    <div className="calendar-day">
                                                                        <div className="calendar-date">
                                                                            {day.date.format(
                                                                                'D',
                                                                            )}
                                                                        </div>

                                                                        {day.data && (
                                                                            <div className="calendar-info">
                                                                                <span className="today-count">
                                                                                    {
                                                                                        day
                                                                                            .data
                                                                                            .presumeYtoDayCnt
                                                                                    }
                                                                                </span>

                                                                                <span className="divider">
                                                                                    |
                                                                                </span>

                                                                                <span className="total-count">
                                                                                    {
                                                                                        day
                                                                                            .data
                                                                                            .presumeYDateCnt
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            );
                                                        })}

                                                        <td className="week-summary">
                                                            <div className="calendar-day">
                                                                <div className="calendar-info">
                                                                    <span className="today-count">
                                                                        {totalTodayCnt}
                                                                    </span>

                                                                    <span className="divider">
                                                                        |
                                                                    </span>

                                                                    <span className="total-count">
                                                                        {avgDateCnt}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            },
                                        );
                                    })()}
                                </tbody>

                            </table>
                        </div>
                    </div>


                    <div className="table-padding-5">
                        <div
                            className="count-item red"
                        ><span style={{ fontWeight: 'bold', color: '#ff0000' }}>
                                {moment(selectedDate).format(
                                    'YYYY년 M월 D일',
                                )}{' '}기준 </span>
                            월별 이력서 등록 현황
                        </div>
                    </div>

                    <div className="group-table">
                        <div className="group-child-table">
                            <table className="table table-gray yearly-summary-table" style={{ width: '70%' }}>
                                <thead>
                                    <tr>
                                        <th rowSpan={2}>구분</th>

                                        <th colSpan={2}>
                                            {moment(selectedDate).year()}년
                                        </th>

                                        <th colSpan={2}>
                                            {moment(selectedDate).year() - 1}년
                                        </th>
                                    </tr>

                                    <tr>
                                        <th>신규</th>
                                        <th>
                                            등록 이력서 총계
                                            <br />
                                            월별 일평균
                                        </th>

                                        <th>신규</th>
                                        <th>평균</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(() => {
                                        const currentYear =
                                            moment(selectedDate).year();

                                        const prevYear =
                                            currentYear - 1;

                                        const currentYearData =
                                            yearlySummary.filter(
                                                (item) =>
                                                    item.yr === currentYear,
                                            );

                                        const prevYearData =
                                            yearlySummary.filter(
                                                (item) =>
                                                    item.yr === prevYear,
                                            );

                                        const currentMap = new Map(
                                            currentYearData.map((item) => [
                                                item.mon,
                                                item,
                                            ]),
                                        );

                                        const prevMap = new Map(
                                            prevYearData.map((item) => [
                                                item.mon,
                                                item,
                                            ]),
                                        );

                                        const currentTotal =
                                            currentYearData.reduce(
                                                (sum, item) =>
                                                    sum + item.sumCnt,
                                                0,
                                            );

                                        const prevTotal =
                                            prevYearData.reduce(
                                                (sum, item) =>
                                                    sum + item.sumCnt,
                                                0,
                                            );

                                        const currentAvg =
                                            currentYearData.length > 0
                                                ? Math.round(
                                                    currentYearData.reduce(
                                                        (sum, item) =>
                                                            sum +
                                                            item.avgCnt,
                                                        0,
                                                    ) /
                                                    currentYearData.length,
                                                )
                                                : 0;

                                        const prevAvg =
                                            prevYearData.length > 0
                                                ? Math.round(
                                                    prevYearData.reduce(
                                                        (sum, item) =>
                                                            sum +
                                                            item.avgCnt,
                                                        0,
                                                    ) /
                                                    prevYearData.length,
                                                )
                                                : 0;

                                        return (
                                            <>
                                                {Array.from({
                                                    length: 12,
                                                }).map((_, idx) => {
                                                    const month = idx + 1;

                                                    const current =
                                                        currentMap.get(
                                                            month,
                                                        );

                                                    const prev =
                                                        prevMap.get(month);

                                                    return (
                                                        <tr key={month}>
                                                            <td>
                                                                {month}월
                                                            </td>

                                                            <td>
                                                                {current?.sumCnt
                                                                    ? Number(
                                                                        current.sumCnt,
                                                                    ).toLocaleString()
                                                                    : ''}
                                                            </td>

                                                            <td>
                                                                {current?.avgCnt
                                                                    ? Number(
                                                                        current.avgCnt,
                                                                    ).toLocaleString()
                                                                    : ''}
                                                            </td>

                                                            <td>
                                                                {prev?.sumCnt
                                                                    ? Number(
                                                                        prev.sumCnt,
                                                                    ).toLocaleString()
                                                                    : ''}
                                                            </td>

                                                            <td>
                                                                {prev?.avgCnt
                                                                    ? Number(
                                                                        prev.avgCnt,
                                                                    ).toLocaleString()
                                                                    : ''}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}

                                                <tr className="total-row">
                                                    <td>Total</td>

                                                    <td>
                                                        {Number(
                                                            currentTotal,
                                                        ).toLocaleString()}
                                                    </td>

                                                    <td>
                                                        {Number(
                                                            currentAvg,
                                                        ).toLocaleString()}
                                                    </td>

                                                    <td>
                                                        {Number(
                                                            prevTotal,
                                                        ).toLocaleString()}
                                                    </td>

                                                    <td>
                                                        {Number(
                                                            prevAvg,
                                                        ).toLocaleString()}
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })()}
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div className="table-padding-5">
                        <div
                            className="count-item red"
                        ><span style={{ fontWeight: 'bold', color: '#ff0000' }}>
                                {moment(selectedDate).format(
                                    'YYYY년 M월 D일',
                                )}{' '}기준 </span>
                            회원 집계
                        </div>
                    </div>

                    <div className="group-table">
                        <div className="group-child-table">
                            {/* 일평균 구인등록 */}
                            <table
                                className="table table-gray member-summary-top"
                                style={{ marginBottom: 20, width: '70%' }}
                            >
                                <tbody>
                                    <tr>
                                        <th
                                            style={{ width: '33.3%' }}
                                        >
                                            일평균 구인등록
                                        </th>

                                        <td>
                                            {Number(
                                                recruitSummaryStats?.totAvg ||
                                                0,
                                            ).toLocaleString()}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* 회원 통계 */}
                            <table className="table table-gray member-summary-table" style={{ width: '70%' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '33.3%' }}>구분</th>
                                        <th>신규</th>
                                        <th>전체회원</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <th style={{ width: '33.3%' }}>치과회원</th>

                                        <td>
                                            {Number(
                                                memberStatsList?.cmemNew ||
                                                0,
                                            ).toLocaleString()}
                                        </td>

                                        <td>
                                            {Number(
                                                memberStatsList?.cmemTot ||
                                                0,
                                            ).toLocaleString()}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th style={{ width: '33.3%' }}>개인회원</th>

                                        <td>
                                            {Number(
                                                memberStatsList?.pmemNew ||
                                                0,
                                            ).toLocaleString()}
                                        </td>

                                        <td>
                                            {Number(
                                                memberStatsList?.pmemTot ||
                                                0,
                                            ).toLocaleString()}
                                        </td>
                                    </tr>

                                    <tr className="total-row">
                                        <th style={{ width: '33.3%' }}>Total</th>

                                        <td>
                                            {Number(
                                                (memberStatsList?.cmemNew ||
                                                    0) +
                                                (memberStatsList?.pmemNew ||
                                                    0),
                                            ).toLocaleString()}
                                        </td>

                                        <td>
                                            {Number(
                                                (memberStatsList?.cmemTot ||
                                                    0) +
                                                (memberStatsList?.pmemTot ||
                                                    0),
                                            ).toLocaleString()}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default MAJAA000;